module.exports = __webpack_public_path__ + "img/quit_icon.d2af4a8c.svg";